import { PipeTransform } from '@angular/core';
import { cnpj, cpf } from 'cpf-cnpj-validator';
var CpfCnpjFormatPipe = /** @class */ (function () {
    function CpfCnpjFormatPipe() {
    }
    CpfCnpjFormatPipe.prototype.transform = function (value) {
        value = String(value);
        if (!value) {
            return value;
        }
        if (value.length === 11) {
            return cpf.format(value);
        }
        if (value.length === 14) {
            return cnpj.format(value);
        }
        return value;
    };
    return CpfCnpjFormatPipe;
}());
export { CpfCnpjFormatPipe };
